module.exports = __webpack_public_path__ + "static/06-540856d8fe65adfa8f0e3e163900e7b0.jpg";